import { catalogs, DEFAULT_LOCALE, type Locale } from './catalogs';

type LeafKeys<T, P extends string = ''> = T extends string
  ? P
  : T extends object
    ? {
        [K in keyof T & string]: LeafKeys<T[K], P extends '' ? K : `${P}.${K}`>;
      }[keyof T & string]
    : never;

export type TranslationKey = LeafKeys<(typeof catalogs)[typeof DEFAULT_LOCALE]>;

let currentLocale = $state<Locale>(DEFAULT_LOCALE);

export function setLocale(locale: Locale): void {
  if (!(locale in catalogs)) {
    throw new Error(`Unsupported locale: ${locale}`);
  }
  currentLocale = locale;
}

export function getLocale(): Locale {
  return currentLocale;
}

export function t(
  key: TranslationKey,
  vars?: Record<string, string | number>
): string {
  const locale = currentLocale;
  const parts = key.split('.');
  let node: unknown = catalogs[locale];
  for (const part of parts) {
    if (node && typeof node === 'object' && part in node) {
      node = (node as Record<string, unknown>)[part];
    } else {
      return key;
    }
  }
  if (typeof node !== 'string') {
    return key;
  }
  if (!vars) {
    return node;
  }
  return node.replace(/\{(\w+)\}/g, (_, name: string) => {
    const value = vars[name];
    return value === undefined ? `{${name}}` : String(value);
  });
}

export type { Locale };
export { SUPPORTED_LOCALES } from './catalogs';